module.exports = __webpack_public_path__ + "img/company-icon.da176646.svg";